export default __webpack_public_path__ + "static/media/ligplaatsen.c749ff13.svg";